import AuthRepository from '@/js/repositories/AuthRepository'
import i18n from '@/lang/i18n';

const state = {
  emailReset: '',
  token: '',
  refreshToken: '',
  resetInfo: {},
  doctorInfo: {},
  errorSendEmail: '',
  errorChangePassword: '',
  errorFirstResetPassword: '',
  fcmToken: '',
  rememberMe: false,
  updateDoctorErr: false,
  needReset: false,
  errorLogin: '',
  typeOfUser: '',
  access_check: null,
  errConfirmChangeEmail: '',
  resendConfirmCodeErr: '',
  access_token: '',
  emailChange: '',
  session: "",
  errorVerifyCode: "",
  attributeUser: "",
  errAddPhoneNumber: "",
  errConfirmPhoneNumber: "",
  phoneNumber: "",
  errorInputCode: "",
  isFirstTimeRegisterPhone: false,
}

const getters = {
  patientHistoriesFlg: (state) => {
    let doctorInfo = state.doctorInfo
    return doctorInfo.patient_histories_flg
  }
}

const actions = {
  logout ({ commit }) {
    commit('INIT')
  },
  setEmailReset ({ commit }, data) {
    commit('EMAIL_RESET', data)
  },
  setToken ({ commit }, data) {
    commit('TOKEN', data)
  },
  setAccessToken ({ commit }, data) {
    commit('ACCESS_TOKEN', data)
  },
  setChangeEmail ({ commit }, data) {
    commit('CHANGE_EMAIL', data)
  },
  setRefreshToken ({ commit }, data) {
    commit('REFRESH_TOKEN', data)
  },
  setResetInfo ({ commit }, data) {
    commit('RESET_INFO', data)
  },
  setFcmToken ({ commit }, data) {
    commit('FCM_TOKEN', data)
  },
  async getDoctorInfo ({ commit }) {
    await AuthRepository.getDoctorInfo()
      .then(resp => {
        commit('DOCTOR_INFO', resp.data.data)
      })
      .catch(error => {})
  },
  firstResetPassword ({ commit }, data) {
    AuthRepository.firstResetPassword(data)
      .then(resp => {
        commit('FIRST_RESET_PASSWORD_ERROR', '')
      })
      .catch(error => {
        commit('FIRST_RESET_PASSWORD_ERROR', i18n.t('api_has_occurred_with_status', {status: error.response.status}))
      })
  },
  async sendResetLink ({ commit }, data) {
    await AuthRepository.sendResetLink(data)
      .then(resp => {
        commit('SEND_EMAIL_ERROR', '')
        commit('EMAIL_RESET', data)
      })
      .catch(error => {
        let errMsg = ''
        if (error.response.status === 404 || error.response.status === 400) {
          errMsg = i18n.t('the_email_address_is_incorrect_with_status', {status: error.response.status})
        } else {
          errMsg = i18n.t('api_has_occurred_with_status', {status: error.response.status})
        }
        commit('SEND_EMAIL_ERROR', errMsg)
      })
  },
  async resetPassword ({ commit }, data) {
    await AuthRepository.resetPassword(data)
      .then(resp => {
        commit('CHANGE_PASSWORD_ERROR', '')
      })
      .catch(error => {
        let errMsg = ''
        if (error.response.data.error = "CodeMismatchException") {
          errMsg = i18n.t('the_verification_code_is_different_with_status', {status: error.response.status})
        } else {
          errMsg = i18n.t('api_has_occurred_with_status', {status: error.response.status})
        }
        commit('CHANGE_PASSWORD_ERROR', errMsg)
      })
  },
  async refreshToken ({ commit }, data) {
    await AuthRepository.refreshToken(data)
      .then(resp => {
        commit('TOKEN', resp.data.token)
        commit('ACCESS_TOKEN', resp.data.AccessToken)
      })
      .catch(error => {
      })
  },
  setRememberMe ({ commit }, data) {
    commit('REMEMBER_ME', data)
  },
  async updateDoctor ({ commit, state }, data) {
    await AuthRepository.updateDoctor(data)
      .then(resp => {
        commit('DOCTOR_INFO', resp.data.data)
        commit('SET_UPDATE_DOCTOR_ERR', false)
      })
      .catch(error => {
        commit('SET_UPDATE_DOCTOR_ERR', true)
      })
  },
  async loginFromDrNanamedi({ commit }, payload) {
    await AuthRepository.loginFromDrNanamedi(payload)
      .then(resp => {
        commit('SET_ERROR_LOGIN', '')
        commit('TOKEN', resp.data.data.token)
        commit('ACCESS_TOKEN', resp.data.data.AccessToken)
        commit('REFRESH_TOKEN', resp.data.data.RefreshToken)
        commit('SET_NEED_RESET', resp.data.need_reset)
        commit('SET_TYPE_OF_USER', resp.data.data.type_of_user ? resp.data.data.type_of_user : 'doctor')
      })
      .catch(error => {
        let errorMsg = ''
        if (error.response.status === 404 || error.response.status === 400) {
          errorMsg = i18n.t('the_email_address_or_password_is_incorrect')
        } else {
          errorMsg = i18n.t('not_connected_to_the_network')
        } 
        commit('SET_ERROR_LOGIN', errorMsg)
      })
  },
  async login ({ commit }, payload) {
    if(payload.hasOwnProperty("token") && payload.hasOwnProperty("refresh_token")) {
      await AuthRepository.loginWithPharmacy(payload)
      .then(resp => {
        const result = {
          email: payload.email,
          password: payload.password
        }
        commit('SET_ERROR_RESEND_CONFIRMATION_CODE', '')
        commit('ACCESS_TOKEN', resp.data.data.AccessToken)
        commit('SET_ERROR_LOGIN', '')
        commit('TOKEN', resp.data.data.AccessToken)
        commit('REFRESH_TOKEN', resp.data.data.RefreshToken)
        commit('SET_NEED_RESET', resp.data.need_reset ? resp.data.need_reset : false)
        commit('SET_TYPE_OF_USER', resp.data.data.type_of_user ? resp.data.data.type_of_user : 'doctor')
        commit('DOCTOR_INFO', 
          {
            email: resp.data.data.user.email,
            id: resp.data.data.user.id,
            name: resp.data.data.user.name,
            company_name: resp.data.data.user.company,
            pharmacy_name: resp.data.data.user.pharmacy,
            patient_histories_flg: 1
          }
        )
      })
    }
    else {
      await AuthRepository.login(payload)
      .then(resp => {
        const result = {
          email: payload.email,
          password: payload.password
        }
        if (resp.data.data.session) {
          commit("SET_NEED_RESET", false)
          commit("setSession", resp.data.data.session)
          commit("RESET_INFO", result)
          commit('SET_ERROR_LOGIN', '')
        } else {
          commit('SET_ERROR_LOGIN', '')
          commit('SET_ERROR_RESEND_CONFIRMATION_CODE', '')
          commit('TOKEN', resp.data.data.IdToken)
          commit('ACCESS_TOKEN', resp.data.data.AccessToken)
          commit('REFRESH_TOKEN', resp.data.data.RefreshToken)
          commit('SET_NEED_RESET', resp.data.need_reset)
          commit('SET_TYPE_OF_USER', resp.data.data.type_of_user ? resp.data.data.type_of_user : 'doctor')
        }
      })
      .catch(error => {
        let errorMsg = ''
        if (error.response.status === 404 || error.response.status === 400) {
          errorMsg = i18n.t('the_email_address_or_password_is_incorrect_with_status', {status: error.response.status})
        } else {
          errorMsg = i18n.t('api_has_occurred_with_status', {status: error.response.status})
        } 
        commit('SET_ERROR_LOGIN', errorMsg)
      })
    }
  },
  async checkAccess({ commit }) {
    await AuthRepository.checkAccess()
      .then(resp => {
        commit('SET_ACCESS_CHECK', resp.data.message === i18n.t('accessable') ? true : false )
      })
      .catch(error => {
        commit('SET_ACCESS_CHECK', false)
      })
  },
  async changeEmail ({ commit }, data) {
    await AuthRepository.changeEmail(data)
      .then(resp => {
        commit('SEND_EMAIL_ERROR', '')
        commit('CHANGE_EMAIL', data)
      })
      .catch(error => {
        let errMsg = ''
        if (error.response.status === 404 || error.response.status === 400) {
          errMsg = "すでに登録されているメールアドレスです。別のメールアドレスを入力してください。"
        } else {
          errMsg = i18n.t('api_has_occurred_with_status')
        }
        commit('SEND_EMAIL_ERROR', errMsg)
      })
  },
  async confirmChangeEmail({ commit }, data) {
    await AuthRepository.confirmChangeEmail(data)
      .then(resp => {
        commit("SET_ERROR_CONFIRM_CHANGE_EMAIL", '')
      })
      .catch(error => {
        let errMsg = ''
        if (error.response.data.error = "CodeMismatchException") {
          errMsg = i18n.t('the_verification_code_is_different_with_status')
        } else {
          errMsg = i18n.t('api_has_occurred_with_status')
        }
        commit('SET_ERROR_CONFIRM_CHANGE_EMAIL', errMsg)
      })
  },
  async resendConfirmationCode ({ commit }, data) {
    await AuthRepository.resendConfirmationCode(data)
      .then(resp => {
        let msg = resp.data.success
        commit('SET_ERROR_RESEND_CONFIRMATION_CODE', msg)
      })
      .catch(error => {
        let errMsg = error.response.data.error
        commit('SET_ERROR_RESEND_CONFIRMATION_CODE', errMsg)
      })
  },
  async verifyMfa({ commit }, data) {
    await AuthRepository.verifyMfa(data)
      .then(resp => {
        if (resp.data.data.session) {
          commit("setSession", resp.data.data.session)
          commit("setErrorVerifyCode", '')
          commit("setErrorInputCode", '')
        } else {
          commit('TOKEN', resp.data.data.IdToken)
          commit('ACCESS_TOKEN', resp.data.data.AccessToken)
          commit('REFRESH_TOKEN', resp.data.data.RefreshToken)
          commit('SET_NEED_RESET', resp.data.need_reset)
          commit('SET_TYPE_OF_USER', resp.data.data.type_of_user ? resp.data.data.type_of_user : 'doctor')
          commit("setErrorVerifyCode", '')
          commit("setErrorInputCode", '')
        }
      })
      .catch(error => {
        let errMsg = ""
        if (error.response.data.error === "Input wrong code") {
          errMsg = "確認コードが正しくありません。"
          commit("setErrorInputCode", errMsg)
        } else if (error.response.data.error === "Session expired") {
          errMsg = "確認コードの有効期限が切れています。"
          commit("setErrorVerifyCode", errMsg)
        } else {
          commit("setErrorVerifyCode", error.response.data.error)
        }
      })
  },
  async checkLoginDevice({ commit }, data) {
    await AuthRepository.checkLoginDevice(data)
      .then(resp => {})
      .catch(error => {})
  },
  clearErrMessage({ commit }) {
    commit("setErrorVerifyCode", '')
    commit("setErrConfirmPhoneNumber", '')
    commit("setErrorInputCode", '')
    commit("SET_ERROR_RESEND_CONFIRMATION_CODE", '')
    commit("SET_ERROR_CONFIRM_CHANGE_EMAIL", '')
  },
  async getAttributeUser({ commit }, data) {
    await AuthRepository.getAttributeUser(data)
      .then(resp => {
        commit("setAttributeUser", resp.data.data)
      })
      .catch(error => {
        commit("setAttributeUser", error.response.data.message)
      })
  },
  async addPhoneNumber({ commit }, data) {
    await AuthRepository.addPhoneNumber(data)
      .then(resp => {
        if (resp.data.success) {
          commit("setErrAddPhoneNumber", '')
          commit("setPhoneNumber2FA", data.phone_number)
        } else {
          commit("setErrAddPhoneNumber", resp.data.error)
        }
      })
      .catch(error => {
        commit("setErrAddPhoneNumber", error.response.data.error)
      })
  },
  async confirmPhoneNumber({ commit }, data) {
    await AuthRepository.confirmPhoneNumber(data)
      .then(resp => {
        commit("setErrConfirmPhoneNumber", '')
      })
      .catch(error => {
        var errMsg = ""
        if (error.response.data.error === "code mismatch") {
          errMsg = "確認コードが違います。"
        } else if (error.response.data.error === "code expired") {
          errMsg = "確認コードの有効期限が切れています。"
        } else if (error.response.data.error === "token expired") {
          errMsg = "トーケンの有効期限が切れました。"
        }
        commit("setErrConfirmPhoneNumber", errMsg)
      })
  },
  async setMFA({ commit }, data) {
    await AuthRepository.setMFA(data)
      .then(resp => {
        commit("setIsFirstTimeRegisterPhone", data.isFirstTimeRegisterPhone)
      })
      .catch(error => {})
  },
  setDefaultFirstTimeRegisterPhone({ commit }) {
    commit("setIsFirstTimeRegisterPhone", false)
  }
}

const mutations = {
  INIT (state) {
    state.token = '',
    state.refreshToken = ''
    state.doctorInfo = {},
    state.rememberMe = false,
    state.errorLogin = '',
    state.typeOfUser = ''
    state.emailChange = ''
    state.access_token = ''
    state.session = ''
  },
  EMAIL_RESET (state, data) {
    state.emailReset = data
  },
  TOKEN (state, data) {
    state.token = data
  },
  ACCESS_TOKEN (state, data) {
    state.access_token = data
  },
  CHANGE_EMAIL (state, data) {
    state.emailChange = data
  },
  REFRESH_TOKEN (state, data) {
    state.refreshToken = data
  },
  RESET_INFO (state, data) {
    state.resetInfo = data
  },
  DOCTOR_INFO (state, data) {
    state.doctorInfo = data
  },
  FCM_TOKEN (state, data) {
    state.fcmToken = data
  },
  SEND_EMAIL_ERROR (state, errMsg) {
    state.errorSendEmail = errMsg
  },
  CHANGE_PASSWORD_ERROR (state, errMsg) {
    state.errorChangePassword = errMsg
  },
  FIRST_RESET_PASSWORD_ERROR (state, errMsg) {
    state.errorFirstResetPassword = errMsg
  },
  REMEMBER_ME (state, data) {
    state.rememberMe = data
  },
  SET_UPDATE_DOCTOR_ERR (state, bool) {
    state.updateDoctorErr = bool
  },
  SET_NEED_RESET (state, bool) {
    state.needReset = bool
  },
  SET_ERROR_LOGIN (state, msg) {
    state.errorLogin = msg
  },
  SET_TYPE_OF_USER (state, msg) {
    state.typeOfUser = msg
  },
  SET_ACCESS_CHECK(state, data) {
    state.access_check = data !== null ? data : null
  },
  SET_ERROR_CONFIRM_CHANGE_EMAIL(state, msg) {
    state.errConfirmChangeEmail = msg
  },
  SET_ERROR_RESEND_CONFIRMATION_CODE(state, msg) {
    state.resendConfirmCodeErr = msg
  },
  setSession(state, data) {
    state.session = data
  },
  setErrorVerifyCode(state, msg) {
    state.errorVerifyCode = msg
  },
  setAttributeUser(state, data) {
    state.attributeUser = data
  },
  setErrAddPhoneNumber(state, error) {
    state.errAddPhoneNumber = error
  },
  setErrConfirmPhoneNumber(state, error) {
      state.errConfirmPhoneNumber = error
  },
  setPhoneNumber2FA(state, data) {
      state.phoneNumber = data
  },
  setErrorInputCode(state, error) {
      state.errorInputCode = error
  },
  setIsFirstTimeRegisterPhone(state, data) {
    state.isFirstTimeRegisterPhone = data
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}